import { configureStore } from '@reduxjs/toolkit'
import laserDataReducer from '../reducer/LaserDataSlice';
import processingReducer from "../reducer/ProcessingSlice";
import calcSettingsReducer from "../reducer/CalcSettingsSlice";
import scansReducer from "../reducer/ScansSlice";
import scanUploadReducer from "../reducer/ScanUploadSlice";
import authReducer from "../reducer/AuthSlice";
import rawSurfaceReducer from "../reducer/RawSurfaceSlice";

export default configureStore({
  reducer: {
    auth: authReducer,
    calcSettings: calcSettingsReducer,
    laserData: laserDataReducer,
    processing: processingReducer,
    rawSurface: rawSurfaceReducer,
    scans: scansReducer,
    upload: scanUploadReducer,
  },
})